import React from 'react'
import frameX from '../../assets/images/smallxmark.png'
import Counter from '../Counter'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './titlePage.css'
import CategoryBtns from '../CategoryBtns'
export default function TitlePage() {
  const navigate = useNavigate()

  return (
    <div className="title_content">
      <div className="title-content-firsttop">
        <div className="title_content_top">
          <p className="title2">Title</p>
          <img
            className="close"
            src={frameX}
            onClick={() => navigate(-1)}
            style={{ marginTop: '3px' }}
            alt="close"
          />
        </div>
        <div className="days">
          <div className="days-content">
            <p className="body2" style={{ color: 'var(--gray100)' }}>
              Number of days
            </p>
            <Counter />
          </div>
        </div>
        <div className="category-tittle">
          <p className="body2" style={{ color: 'var(--gray100)' }}>
            Trip categories
          </p>
          <CategoryBtns />
        </div>
      </div>
      <div className="title_content_bottom">
        <div className="clear_filter">
          <img
            className="close"
            src={frameX}
            style={{ marginRight: '5px' }}
            alt="close"
          />
          <p>Clear filters</p>
        </div>
        <button>Apply filters</button>
      </div>
    </div>
  )
}
